import React, {useEffect, useState} from 'react';
import config from '../../config/index';
import {makeStyles} from '@material-ui/core/styles';
import {httpGet} from "../../api/http-functions";
import {run} from "../../utils/function-util";
import defaultAvatar from './avatar.png';

const avatarUrls = new Map();

const useStyles = makeStyles({
    root: {
        display: 'flex',
        borderRadius: '50%',
        overflow: 'hidden',
        width: '45px',
        height: '45px'
    },
    avatar: {
        width: '100%',
        height: '100%',
        flexGrow: 0,
        flexShrink: 1,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        alignSelf: 'center'
    }
});

const getAvatar = async (url: string) => {
    const resp = await httpGet(url, { responseType: 'blob' });
    return resp.data;
}

const getAvatarUrl = async (userId: string): Promise<string> => {
    let avatar;
    try {
        avatar = await getAvatar(`${config.api}/profiles/${userId}/avatar`)
    } catch (e) {
        return defaultAvatar;
    }

    if (avatarUrls.has(userId)) {
        return avatarUrls.get(userId)
    } else {
        let url = URL.createObjectURL(avatar)
        avatarUrls.set(userId, url)
        return url
    }
}

const UserAvatar = ({userId}: { userId: string | undefined }) => {
    const [avatarUrl, setAvatarUrl] = useState<string>();
    const classes = useStyles();

    useEffect(run(async () => !!userId ? await getAvatarUrl(userId) : Promise.resolve(defaultAvatar), setAvatarUrl), []);

    return <div className={classes.root}>
               <div className={classes.avatar} style={{backgroundImage:`url(${avatarUrl})`}}></div>
           </div>
};


export default UserAvatar;
